const { registerBlockType } = wp.blocks;
const {
    useBlockProps,
    RichText,
    InspectorControls,
    ColorPalette,
    MediaUpload,
} = wp.blockEditor;
const { PanelBody, Button, RangeControl } = wp.components;
// import registerBlockType from wp.blocks;

registerBlockType("rmedina/custom-cta", {
    // built-in attributes
    title: "Call to Action",
    description: "Block to generate a custom Call to Action",
    icon: "format-image",
    category: "widgets",

    // custom attributes
    attributes: {
        title: {
            type: "string",
            source: "html",
            selector: "h2",
        },
        titleColor: {
            type: "string",
            default: "black",
        },
        body: {
            type: "string",
            source: "html",
            selector: "p",
        },
        backgroundImage: {
            type: "string",
            default: null,
        },
        overlayColor: {
            type: "string",
            default: "black",
        },
        overlayOpacity: {
            type: "number",
            default: 0.3,
        },
    },

    // custom functions

    // built-in functions
    edit({ attributes, setAttributes }) {
        const {
            title,
            body,
            titleColor,
            backgroundImage,
            overlayColor,
            overlayOpacity,
        } = attributes;

        function onChangeTitle(newTitle) {
            setAttributes({ title: newTitle });
        }
        function onChangeBody(newBody) {
            setAttributes({ body: newBody });
        }
        function onTitleColorChange(newColor) {
            setAttributes({ titleColor: newColor });
        }
        function onSelectImage(newImage) {
            setAttributes({ backgroundImage: newImage.sizes.full.url });
        }
        function onOverlayColorChange(newColor) {
            setAttributes({ overlayColor: newColor });
        }
        function onOverlayOpacityChange(newOpacity) {
            setAttributes({ overlayOpacity: newOpacity });
        }

        return [
            <div {...useBlockProps()}>
                <InspectorControls style={{ marginBottom: "40px" }}>
                    <PanelBody title={"Font Color Settings"}>
                        <p>
                            <strong>Select a Title color:</strong>
                        </p>
                        <ColorPalette
                            value={titleColor}
                            onChange={onTitleColorChange}></ColorPalette>
                    </PanelBody>
                    <PanelBody title={"Background Image Settings"}>
                        <p>
                            <strong>Select a Background Image:</strong>
                        </p>
                        <MediaUpload
                            onSelect={onSelectImage}
                            type="image"
                            value={backgroundImage}
                            render={({ open }) => (
                                <Button
                                    onClick={open}
                                    icon="upload"
                                    className="editor-media-placeholder__button is-button is-default is-large">
                                    Background Image
                                </Button>
                            )}
                        />
                        <div
                            style={{ marginTop: "20px", marginBottom: "40px" }}>
                            <p>
                                <strong>Overlay Color:</strong>
                            </p>
                            <ColorPalette
                                value={overlayColor}
                                onChange={onOverlayColorChange}></ColorPalette>
                        </div>
                        <div
                            style={{ marginTop: "20px", marginBottom: "40px" }}>
                            <p>
                                <strong>Overlay Opacity</strong>
                            </p>
                            <RangeControl
                                label={"Overlay Opacity"}
                                value={overlayOpacity}
                                onChange={onOverlayOpacityChange}
                                min={0}
                                max={1}
                                step={0.01}
                            />
                        </div>
                    </PanelBody>
                </InspectorControls>
                <div
                    className="cta-container"
                    style={{
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}>
                    <div
                        className="cta-overlay"
                        style={{
                            background: overlayColor,
                            opacity: overlayOpacity,
                        }}></div>
                    <RichText
                        key="editable"
                        tagName="h2"
                        placeholder="Your CTA Title"
                        value={title}
                        onChange={onChangeTitle}
                        style={{ color: titleColor }}
                    />
                    <RichText
                        key="editable"
                        tagName="p"
                        placeholder="Your CTA Description"
                        value={body}
                        onChange={onChangeBody}
                    />
                </div>
            </div>,
        ];
    },

    save({ attributes }) {
        const {
            title,
            body,
            titleColor,
            backgroundImage,
            overlayColor,
            overlayOpacity,
        } = attributes;

        return (
            <div
                className="cta-container"
                {...useBlockProps.save()}
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}>
                <div
                    className="cta-overlay"
                    style={{
                        background: overlayColor,
                        opacity: overlayOpacity,
                    }}></div>
                <h2 style={{ color: titleColor }}>{title}</h2>
                <RichText.Content tagName="p" value={body} />
            </div>
        );
    },
});
